import EmailAddress from "common/values/email-address/email-address";

export default class AcceptOpenEntityMemberInvitationAPIRequest {
    emailAddress: string;

    constructor(emailAddress: EmailAddress) {
        this.emailAddress = emailAddress.value;
    }
}
